import { __assign } from "tslib";
var noop = function () { return ({}); };
var width = 2560;
var height = 1440;
export var dimsMock = {
    y: 0,
    x: 0,
    width: width,
    height: height,
    innerWidth: width,
    innerHeight: height,
    outerWidth: width,
    outerHeight: height,
    clientWidth: width,
    clientHeight: height,
};
var elem = __assign(__assign({}, dimsMock), { getBoundingClientRect: function () { return dimsMock; } });
var documentMock = __assign({ addEventListener: noop, removeEventListener: noop, createEvent: noop, getElementById: function () { return elem; }, getElementsByClassName: function () { return [elem]; }, getElementsByTagName: function () { return [elem]; }, querySelector: function () { return [elem]; }, documentElement: elem, activeElement: elem, style: dimsMock }, dimsMock);
documentMock.body = documentMock;
var locationMock = {
    href: 'http://mock.wix.com/',
    protocol: 'http:',
    host: 'mock.wix.com',
    hostname: 'mock.wix.com',
    port: '',
    pathname: '/',
    search: '',
    hash: '',
};
export var scrollMock = {
    scrollTop: 0,
    scrollY: 0,
};
var windowHydrateMock = __assign(__assign({}, dimsMock), scrollMock);
var windowMock = __assign({ isMock: true, isSSR: true, orientation: 0, devicePixelRatio: 1, addEventListener: noop, removeEventListener: noop, createEvent: noop, CustomEvent: noop, screen: dimsMock, open: noop, petri: {}, search: {}, location: locationMock, postMessage: noop, requestAnimationFrame: noop, dispatchEvent: noop, document: documentMock, getComputedStyle: noop, localStorage: {}, frames: [] }, windowHydrateMock);
export var hydrateMockMap = new Map(Object.keys(windowHydrateMock).map(function (key) { return [key, windowHydrateMock[key]]; }));
windowMock.parent = windowMock;
export default windowMock;
//# sourceMappingURL=window.mock.js.map